import { validateArguments } from '../../SignatureValidation';
export var FirstFn;
(function (FirstFn) {
    FirstFn.Name = `FIRST`;
    FirstFn.Stage = "ANALYTIC";
    FirstFn.Signature = `FIRST()`;
    function make(callName, args, type, role) {
        return {
            name: FirstFn.Name,
            stage: FirstFn.Stage,
            data: { type, role },
            value: (context) => {
                const { state, frame: { index }, } = context;
                return { state, value: index === 0 ? 0 : -1 * index };
            },
        };
    }
    FirstFn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            meta: { name: FirstFn.Name, signature: FirstFn.Signature, location: callNode.location },
            arguments: [],
        };
        return validateArguments(sig, args);
    }
    FirstFn.validate = validate;
})(FirstFn || (FirstFn = {}));
